<template>
    <div class="ivu-tooltip-dark ivu-tooltip-popper qa-banner-cursor-info" x-placement="top" :style="style">
        <div class="ivu-tooltip-content">
            <div class="ivu-tooltip-arrow"></div>
            <div class="ivu-tooltip-inner">Click to annotate</div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
const manualOffset = {
    x: 69,
    y: 52
};

const withHeaderOffset = {
    x: 69,
    y: 93
};

export default defineComponent({
    name: "QaBannerCursorInfo",

    props: {
        hasHeader: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            parentBoundingRect: {
                top: 0,
                left: 0
            },
            style: {
                top: "0",
                left: "0"
            } as {
                top: string;
                left: string;
                willChange: string;
            }
        };
    },

    computed: {
        offset() {
            if (this.hasHeader) {
                return withHeaderOffset;
            }

            return manualOffset;
        }
    },
    created() {
        document.addEventListener("mousemove", this.updatePosition, false);
    },

    mounted() {
        this.parentBoundingRect = (this.$parent?.$el as HTMLElement).getBoundingClientRect();
    },

    beforeUnmount() {
        document.removeEventListener("mousemove", this.updatePosition, false);
    },

    methods: {
        updatePosition(event: MouseEvent) {
            this.style = {
                willChange: "top, left",
                left: `${event.pageX - this.parentBoundingRect.left - this.offset.x}px`,
                top: `${event.pageY - this.parentBoundingRect.top - this.offset.y}px`
            };
        }
    }
});
</script>

<style lang="scss">
@use "@style/variables" as *;

.qa-banner-cursor-info {
    display: none;
    z-index: $zindex-qa-cursor-info;
}
</style>
